module.exports = __webpack_public_path__ + "static/img/cjzh-coreTechnology.6e74b037.png";